import React from 'react';
import { Icon, Title } from '@common/components';
import {
  faEnvelope,
  faKey,
  faPlane,
  faWarning,
} from '@fortawesome/free-solid-svg-icons';
import iconClasses from './IconSampleView.module.scss';

export default function IconSampleView() {
  return (
    <div className={iconClasses.icon}>
      <Title type="h1">Icon demo</Title>
      <div className={iconClasses.iconGrid}>
        <div className={iconClasses.item}>
          <Icon icon={faEnvelope} />
          <span>normal</span>
        </div>
        <div className={iconClasses.item}>
          <Icon icon={faKey} color="accent" />
          <span>accent</span>
        </div>
        <div className={iconClasses.item}>
          <Icon icon={faPlane} size="2x" color="warning" />
          <span>warning 2x</span>
        </div>
        <div className={iconClasses.item}>
          <Icon icon={faWarning} size="6x" color="error" />
          <span>error 6x</span>
        </div>
      </div>
    </div>
  );
}
